import React from 'react';
import { Button, Icon } from 'rsuite';
export default class Card extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            show: false
        };
        this.show = this.show.bind(this);
        console.log(this.props.palavra);
    }

    show() {
        if (!this.state.show) {
            this.props.tips[this.props.ind - 500] = true;
            this.props.onClick();
            this.setState({ show: this.props.tips[this.props.ind - 500]});
        }
    }

    

    render() {

        //Estilos hide/show ajuda
        var mostra = {
            'display': 'block'
        };

        var hide = {
            'display': 'none'
        };

        // <div className='card border1'
                // style={Object.assign({}, this.props.tipsOpen[this.props.ind - 500] ? mostra : hide, this.props.palavras[this.props.ind - 500] ? acertou : nada) }></div>

        return (
            <div className='card border1'
                style={this.props.tipsOpen[this.props.ind - 500] ? mostra : hide }>
                <div className='col'>
                    <div className='palavraCerta' style={this.props.palavras[this.props.ind - 500] ? mostra : hide}>
                        {'Acertou: '+ this.props.palavra}
                    </div>
                    <p className="Color4">{this.props.dica}</p>
                    <div className='margin-min row fullWidthContent text-center' style={this.props.tips[this.props.ind - 500] ? hide : this.props.palavras[this.props.ind - 500] ? hide : mostra}>
                        <Button onClick={this.show} className="bkColor1 Color4 DestravarDica"> <Icon icon='lock' size="1x" /> DESTRAVAR DICA</Button>
                    </div>
                    <div className='ajuda bkColor6' style={this.props.tips[this.props.ind - 500] ? mostra : hide}>
                        {this.props.ajuda}
                    </div>
                </div>
            </div>
        );
    }
}
